// this is an autogenerated file from DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/BoardItem/IconAndTitle/AssignedToMe/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksBoardsList_Boards_Content_Boards_Content_BoardItem_IconAndTitle_AssignedToMe($user_id: uuid!, $board_id: uuid!) {
  tasks_assignees_aggregate(
    where: {
      user_id: { _eq: $user_id }
      task: { board_id: { _eq: $board_id }, stage: { done: { _eq: false } } }
    }
  ) {
    aggregate {
      count
    }
  }
}

`